module.exports = __webpack_public_path__ + "img/weiwei.731a819d.png";